









































































import Vue from 'vue';
import {
  Component, Inject,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import {
  Alert,
  NoticeClass,
  Dialog,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import { TestResource, Test } from '@/api/test';

enum TestStatus { NOT_RUN, RUNNING, PASSED, FAILED }

interface TestItem
{
  name: string,
  expected: string,
  status: TestStatus,
}


@Component({
  components: {
    KCardHeader,
  },
})
export default class TestsView extends Vue {
  @Inject('TestResource')
  testResource!: TestResource;

  search: string = '';

  tests: TestItem[] = [];

  loading: boolean = false;

  deleting: boolean = false;

  runningTestIndex: number = -1;

  footerProps = {
    'items-per-page-options': [20, 25, 50, 100, -1],
  }

  itemsPerPage: number = 20;

  page: number = 0;


  // Make visible to template
  TestStatus:any = TestStatus;

  headerItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: 'Tests',
      disabled: true,
    },
  ];

    tableHeaders: DataTableHeader[] = [
      {
        text: '', value: 'edit', align: 'start', sortable: false, width: 25,
      },
      {
        text: 'Name', value: 'name', align: 'start', sortable: true,
      },
      {
        text: 'Result', value: 'description', align: 'start', sortable: true,
      },
      {
        text: '', value: '', align: 'start', sortable: false, width: 25,
      },
    ];


    mounted() {
      this.loading = true;
      this.testResource.getAll().then((returnedTests:Test[]) => {
        this.tests = [];
        returnedTests.forEach((test:Test) => {
          this.tests.push({ name: test.name, expected: test.expected, status: TestStatus.NOT_RUN });
        });
      }).catch((error:any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.loading = false;
      });
    }

    onDeleteTest(name: string) {
      const dialog = new Dialog('Confirm Deletion', `Are you sure you want to delete "${name}"?`);
	      dialog.setAcceptLabel('OK')
	        .setDeclineLabel('Cancel');
	      this.$store.dispatch('notices/add', dialog).then((ok) => {
	        if (ok === 'accept') {
          this.deleteTest(name);
        }
      });
    }

    deleteTest(name: string) {
      this.deleting = true;
      this.testResource.delete(name).then((deletedTest:Test) => {
        for (let i = 0; i < this.tests.length; i++) {
          if (this.tests[i].name === name) {
            this.tests.splice(i, 1);
            break;
          }
        }
      }).catch((error:any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.deleting = false;
      });
    }

    runTests() {
      if (this.runningTestIndex === -1 && this.tests.length > 0) {
        this.tests.forEach((test:TestItem) => {
          // eslint-disable-next-line no-param-reassign
          test.status = TestStatus.NOT_RUN;
        });

        this.runNextTest();
      }
    }

    async runNextTest(): Promise<void> {
      this.runningTestIndex++;
      if (this.runningTestIndex >= this.tests.length) {
        // Reached the end
        this.runningTestIndex = -1;
      } else {
        if (this.itemsPerPage !== -1) {
          this.page = Math.ceil((this.runningTestIndex + 1) / this.itemsPerPage);
        }
        this.tests[this.runningTestIndex].status = TestStatus.RUNNING;
        this.testResource.getTestResult(this.tests[this.runningTestIndex].name).then((testResult:string) => {
          if (testResult === this.tests[this.runningTestIndex].expected) {
            this.tests[this.runningTestIndex].status = TestStatus.PASSED;
          } else {
            this.tests[this.runningTestIndex].status = TestStatus.FAILED;
          }
          return this.runNextTest();
        });
      }
    }

    cancelTestRun() {
      if (this.runningTestIndex !== -1) {
        this.tests[this.runningTestIndex].status = TestStatus.NOT_RUN;
        this.runningTestIndex = this.tests.length - 1;
      }
    }

    showErrorMessage(error: any) {
      console.error(error);
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }
}
